export default {
  title: {
    en: 'Please verify your address',
  },
  textNote: {
    en: `
      Did we make a mistake? Simply select <strong>My address is correct</strong>, or select the option to update your info with the right address
      so we can get your order over to you as soon as possible!
    `,
  },
  addressNote: {
    en: 'For your reference, your current address is listed as:',
  },
  updateAddress: {
    en: 'Update the address',
  },
  addressIsCorrect: {
    en: 'My address is correct',
  },
}
